import type { ModuleRenderer } from '../renderer.ts';
import { BoardRenderer } from '../board/BoardRenderer.tsx';

/**
 * `poc-board` declares `capabilities.renderer: 'board'` (see manifest.ts), so it uses the shared board
 * renderer unchanged: the module's own `project()` supplies the title ("Board test"), status lines, controls
 * and highlights, and `BoardRenderer` draws whatever `BoardView` it receives. Nothing here is module-specific.
 */
export const pocBoardClientRenderer: ModuleRenderer = {
  renderer: 'board',
  Component: BoardRenderer,
};
